import { render, staticRenderFns } from "./InterestRateRisk.vue?vue&type=template&id=19d62438&scoped=true"
import script from "./InterestRateRisk.vue?vue&type=script&lang=js"
export * from "./InterestRateRisk.vue?vue&type=script&lang=js"
import style0 from "./InterestRateRisk.vue?vue&type=style&index=0&id=19d62438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d62438",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
